export default __webpack_public_path__ + "static/media/Katia.e20b7295.jpg";